export const useOptions = () => {
    //* 获取i18n
    const i18n = useI18n();
    return {
        //* 推荐工具
        recommendeds: [
            {
                img: "https://rdgta.cdn.cyagen.com/rddc/pictures/78908fbd-0b67-4e8c-a347-18e5b8ea6c2e.webp",
                name: i18n.t("VPP"),
                route: { name: "Pathogenicity" },
                descript: i18n.t("PathoPredictDescribe"),
            },
            {
                img: "https://rdgta.cdn.cyagen.com/rddc/pictures/222cab08-a6b0-40a6-a74a-e04b4505a065.webp",
                name: i18n.t("RNASplicer"),
                route: { name: "RnaSplicer" },
                descript: i18n.t("RNASplicerDescribe"),
            },
            {
                img: "https://rdgta.cdn.cyagen.com/rddc/pictures/da2f6128-1c99-44d5-8bc4-af35e14e6df2.webp",
                name: i18n.t("SequenceAlignment"),
                route: { name: "SequenceAlignment" },
                descript: i18n.t("SequenceAlignmentDescribe"),
            },
            {
                img: "https://rdgta.cdn.cyagen.com/rddc/pictures/9a1251ca-d2e7-4708-b843-914b31ee76aa.webp",
                name: i18n.t("MutationViewer"),
                route: { name: "BioVariant" },
                descript: i18n.t("MutationViewerDescribe"),
            },
        ],
    };
};
